import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { noSpaces, required, spaceOnName } from '../../../../../../../shared/utils';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

export const NODE_TYPE: string = 'math';

export interface MathData {
  name: string,
  description: string,
  expression: string,
  yes: string,
  no: string,
  error: string,
  variables: VariableData[]
}

export interface VariableData {
  key: string,
  value: string
}


export class MathNode {

  action: any = {};

  constructor() {
    this.action = {
      actionType: NODE_TYPE,
    };
  }

  static toForm(step: { [index: string]: string }, editPermissions: EditPermissions): UntypedFormGroup {
    const { editFlows } = getEditTypes(editPermissions);
    const mathData = this.getFormData(step);

    return this.buildForm(mathData, editFlows);
  }

  private static buildForm(mathData: MathData, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      name: new UntypedFormControl({
        value: mathData.name,
        disabled: !editFlows,
      }, [required('Name'), spaceOnName()]),
      description: new UntypedFormControl({
        value: mathData.description,
        disabled: !editFlows,
      }, required('Description')),
      expression: new UntypedFormControl({
        value: mathData.expression,
        disabled: !editFlows,
      }, [required('Expression'), noSpaces('Expression Can`t contain spaces')]),
      yes: new UntypedFormControl({
        value: mathData.yes,
        disabled: !editFlows,
      }),
      no: new UntypedFormControl({
        value: mathData.no,
        disabled: !editFlows,
      }),
      error: new UntypedFormControl({
        value: mathData.error,
        disabled: !editFlows,
      }),
      variables: this.buildVariables(mathData.variables, editFlows),
    });
  }

  private static getFormData(step): MathData {

    const action = step?.action ? step?.action : {};
    const actionParams = action.actionParams ? action.actionParams : {};
    const results = action.result ? action.result : {};

    return {
      name: action['name'] ? action['name'] : '',
      description: action['description'] ? action['description'] : '',
      variables: this.getVariables(actionParams.variables),
      expression: actionParams.expression ? actionParams.expression : '',
      yes: results.yes ? results.yes : newStepValue,
      no: results.no ? results.no : newStepValue,
      error: results.error ? results.error : newStepValue,
    };
  }

  private static getVariables(variables: {}): VariableData[] {

    const tmpVariables: VariableData[] = [];

    if (variables) {
      for (const [key, value] of Object.entries(variables)) {
        tmpVariables.push({
          key,
          value: value as string,
        });
      }
    }

    return tmpVariables;
  }

  private static buildVariables(value: VariableData[], editFlows: boolean): UntypedFormArray {

    const varFormArray = new UntypedFormArray([]);

    if (value && value.length > 0) {
      for (let variable of value) {
        varFormArray.push(this.variableTemple(variable.key, variable.value, editFlows));
      }
    } else {
      varFormArray.push(this.variableTemple('', '', editFlows));
    }

    return varFormArray;
  }

  public static variableTemple(key: string, value: string, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      key: new UntypedFormControl({
        value: key,
        disabled: !editFlows,
      }, required('Key')),
      value: new UntypedFormControl({
        value: value,
        disabled: !editFlows,
      }, required('Value')),
    });
  }

  private getVariables(variables: VariableData[]): {} {

    const vars = {};

    for (let { key, value } of variables) {
      vars[key] = value;
    }

    return vars;
  }

  public addMathData(mathData: MathData) {
    const { name, description, variables, expression, yes, no, error } = mathData;

    const actionParams = {
      variables: this.getVariables(variables),
      expression,
    };
    const result = {
      yes,
      no,
      error,
    };

    this.action = {
      ...this.action,
      name,
      description,
      actionParams,
      result,
    };
  }

  get nodeData(): {} {
    return {
      action: this.action,
      'type': 'action',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }

}
